import "./widget_core.js"
var req = require.context('../../../public/javascripts/backbone/apps/single_photo/', true, /\.js$/)
req.keys().forEach(req)
